import { client } from 'components/ApolloProvider'
import * as CAT from '../voohCreation/types' // Creation API types
import { ModalUploadFile } from 'components/Modal/ModalUpload'
import {
  VoohCampaignForm,
  VoohCreation,
  VoohMediaFormat,
  VoohUsedMedia,
} from '../../../pages/VoohCampaign/VoohCampaignForm/types'
import { UPDATE_VOOH_CAMPAIGN_CREATION } from './updateVoohCampaignCreation'
import { GET_VOOH_CREATION } from './getVoohCreation'
import { Creation, CreationSchedule } from '../../../types/campaign'
import { FetchResult } from '@apollo/client'
import { MutationStateResponse } from '../../../types/various'
import { UPDATE_VOOH_CREATION_SCHEDULES } from './updateVoohCreationSchedule'
import { UPDATE_VOOH_CREATION_MEDIA } from './updateVoohCreationMedia'
import { CREATE_VOOH_CREATIONS } from './createVoohCreation'
import { DELETE_VOOH_CREATION } from './destroyVoohCreation'
import { ARCHIVE_VOOH_CREATION } from './archiveVoohCreation'

const voohCreationsApi = {
  createVoohCreations: (variables: {
    voohCampaignId: VoohCampaignForm['id']
    details: string
    mediaFormat: VoohMediaFormat
    files: ModalUploadFile[]
    duration: number
    hourFrequency: number
  }): Promise<CAT.CreateVoohCreationsFR> =>
    client.mutate({
      mutation: CREATE_VOOH_CREATIONS,
      variables,
      errorPolicy: 'all',
    }),

  updateVoohCampaignCreation: (variables: {
    voohCreationId: VoohCreation['id']
    details: string
    mediaFormat: VoohMediaFormat
    duration: number
    hourFrequency: number
  }): Promise<CAT.UpdateVoohCreationsFR> =>
    client.mutate({
      mutation: UPDATE_VOOH_CAMPAIGN_CREATION,
      variables,
      errorPolicy: 'all',
    }),

  getVoohCreation: (id: VoohCreation['id']): Promise<CAT.GetVoohCreationAQR> => {
    return client.query({
      query: GET_VOOH_CREATION,
      variables: { id },
    })
  },

  updateVoohCreationSchedule: (
    voohCreationId: Creation['id'],
    schedules: CreationSchedule[]
  ): Promise<FetchResult<{ updateVoohCreationSchedules: MutationStateResponse }>> =>
    client.mutate({
      mutation: UPDATE_VOOH_CREATION_SCHEDULES,
      variables: { voohCreationId, schedules },
    }),

  updateVoohCreationMedia: (
    voohCreationId: Creation['id'],
    media: VoohUsedMedia[]
  ): Promise<FetchResult<{ updateVoohCreationMedia: MutationStateResponse }>> =>
    client.mutate({
      mutation: UPDATE_VOOH_CREATION_MEDIA,
      variables: { voohCreationId, media },
    }),

  deleteVoohCreation: (voohCreationId: Creation['id']): Promise<CAT.DeleteVoohCreationFR> =>
    client.mutate({
      mutation: DELETE_VOOH_CREATION,
      variables: { voohCreationId },
    }),

  archiveVoohCreation: (
    voohCreationId: VoohCreation['id'],
    archiveReason: VoohCreation['archiveReason']
  ): Promise<CAT.ArchiveVoohCreationFR> =>
    client.mutate({
      mutation: ARCHIVE_VOOH_CREATION,
      variables: { voohCreationId, archiveReason },
    }),
}

export default voohCreationsApi
